import styled from 'styled-components'
import { Button, Box } from '@mui/material'
import { Indicator, StepsHeader } from '../../components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Footer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

const IndicatorContainer = styled.div`
  margin-top: 32px;
`

const IndicatorItemContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  > span {
    margin-left: 8px;
  }
`



const Instructions = ({ onNext, loading }) => {
  const { t } = useTranslation('common')

  const listInfo = [
    t('onboarding.welcome_page.list.first'),
    t('onboarding.welcome_page.list.second'),
    t('onboarding.welcome_page.list.third')
  ]
  return (
    <Container>
      <ContentContainer>
        <StepsHeader
          stepText={t('onboarding.welcome_page.header')}
          description={t('onboarding.welcome_page.description')}
        />

        <IndicatorContainer>
          {listInfo.map((item, index) => (
            <IndicatorItemContainer key={index}>
              <Indicator number={index + 1} />
              <span>{item}</span>
            </IndicatorItemContainer>
          ))}
        </IndicatorContainer>
      </ContentContainer>
      <Footer>
        <Box />
        <Button
          color='primary'
          variant='contained'
          onClick={onNext}
          disabled={loading}
        >
          {t('onboarding.advance')}
        </Button>
      </Footer>
    </Container>
  )
}

export default Instructions
